// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider  } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDje5ADjl10GsspK0JPDKdvNVdR0v6N57w",
  authDomain: "stadium-now.firebaseapp.com",
  projectId: "stadium-now",
  storageBucket: "stadium-now.appspot.com",
  messagingSenderId: "156988360110",
  appId: "1:156988360110:web:d5f8922e0dbe5047fb343f",
  measurementId: "G-JPBHJ6QDM3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();